import * as Util from "../common/util";
import * as Data from "../interfaces/data";

export interface ITemplatePhrase {
    /// unique ID for the template phrase
    ID: number;

    PhraseName: string;
    IsActive: boolean;
    AdditionalTextLabel1: string;
    AdditionalTextLabel2: string;
    AdditionalNumberLabel1: string;
    AdditionalNumberLabel2: string;
    Details: ITemplatePhraseDetail[];
}

export interface ITemplatePhraseDetail {
    /// unique ID for the template phrase detail
    ID: number;
    Phrase: string;
    SortOrder: number;
    IsActive: boolean;
    AdditionalTextValue1: string;
    AdditionalTextValue2: string;
    AdditionalNumberValue1: number;
    AdditionalNumberValue2: number;
}

export interface ITemplatePhraseRequest {
    TemplatePhraseID: number;
}
export interface ITemplatePhraseResponse {
    ID: number;
}

export function GetTemplatePhraseMaster(request: ITemplatePhraseRequest): JQueryDeferred<Data.IResponse<ITemplatePhrase>> {
    return Util.callWebService(
        "/api/TemplatePhrase/GetTemplatePhrase", "POST", request);
}

export function SaveTemplatePhrase(templatePhrase: any): JQueryDeferred<Data.IResponse<ITemplatePhraseResponse>> {
    return Util.callWebService(
        "/api/TemplatePhrase/SaveTemplatePhrase", "POST", templatePhrase);
}

export function ChangeTemplatePhraseStatus(templatePhraseID: number, isActive: boolean): JQueryDeferred<Data.IResponse<any>> {
    return Util.callWebService(
        "/api/TemplatePhrase/ChangeTemplatePhraseStatus",
        "POST",
        {
            ID: templatePhraseID,
            IsActive: isActive,
        });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/templatePhraseData.ts